export enum SaleTypeEnum {
    askingPrice = 0,
    enquiriesOver = 1,
    auction = 2,
    tender = 3,
    priceByNegotiation = 4,
    deadlinePrivateTreaty = 5
}
